import React, { Component } from 'react';
import API from '../../../api/api';
import './shopDetail.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Form, Upload, Tabs, Icon, Radio, Input, Table, Alert, Button, DatePicker, Select, Modal, message, InputNumber, Popconfirm, ConfigProvider } from 'antd';
import MapModel from '../../components/map/map';
import UEditor from "../../components/ueditor/ueditor";
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { TextArea } = Input;


class ShopDetail extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        isNew: true,
        templateId: '',
        activeKey: '1',
        pagination1: {
            hideOnSinglePage: true,
            showQuickJumper: true,
            showSizeChanger: false,
            addModalTitle: '',
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
        },
        pagination2: {
            hideOnSinglePage: true,
            showQuickJumper: true,
            showSizeChanger: false,
            addModalTitle: '',
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
        },

        shopDetail: null,
        ossData: {}, // 
        visible: false,
        shopDetailloading: false,

        queryCardList: [
            {
                id: '',
                templateId: '',
                cardNum: '',
                isDelete: '',
                userPhone: '', // 返回表示已激活，null 未激活
            },
        ],
        columnsQueryCardList: [
            {
                title: '卡号',
                dataIndex: 'cardNum',
                key: 'cardNum',
            },
            {
                title: '状态',
                key: 'userId',
                render: (data) => (
                    <span> {data.userPhone ? '已激活' : '未激活'}</span>
                ),
            },
            {
                title: '会员',
                dataIndex: 'userPhone',
                key: 'userPhone',
            },
            {
                title: '操作',
                key: 'isDelete',
                render: (data) => (
                    <div className="operateBtnBlock">
                        {
                            data.isDelete == 0 ?
                                <Popconfirm title="确定删除此卡号吗？"
                                    onConfirm={this.couponDeleteCard.bind(this, data)}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button key={'deleteBtn' + data.showId} type="danger" className="deleteBtn">删除</Button>
                                </Popconfirm>
                                : '已删除'
                        }
                    </div>
                ),
            }
        ],
        searchData: {
            pageSize: 10,
            cardNum: '',
            pageNo: 1
        },
        cardListStr: [],
        authInfoModal: {
            show: false
        },

        consumeStatSearchData: {
            startTime: '',
            endTime: '',
            pageNum: 10,
            templateId: '',
            pageNo: 1
        },
        consumeList: [],
        columnsConsumeList: [//直播列表表头
            {
                title: '核销时间',
                dataIndex: 'consumeDateFormat',
                key: 'consumeDateFormat',
            },
            {
                title: '核销金额',
                dataIndex: 'consumeAmount',
                key: 'consumeAmount',
            },
            {
                title: '会员手机号',
                dataIndex: 'userPhone',
                key: 'userPhone',
            },
            {
                title: '会员卡号',
                dataIndex: 'cardNum',
                key: 'cardNum',
            },
        ],

        ShopQrCode: '',

        introduceList: ['', ''], // 办卡二维码的介绍list
        brandCardName: '', // 联名卡名称
    }
    componentDidMount() {
        const { isNew, templateId } = this.props.history.location.state;
        console.log('statys', isNew, templateId);
        this.getSignatureAndPolicy();
        this.setState({
            isNew,
            templateId
        })
        if (!isNew) {
            this.couponShopDetail({ templateId });
            let { consumeStatSearchData, searchData } = this.state;
            consumeStatSearchData.templateId = templateId;
            searchData.templateId = templateId;
            this.setState({ consumeStatSearchData, searchData }, () => {
                this.couponConsumeStat()
                this.couponQueryCardList();
            })
        } else {
            this.setState({
                shopDetail: {
                    shopLogo: '',
                    shopLogoLoading: false,
                    shopName: '',
                    shopAddress: '',
                    location: '',
                    adminPhones: '',
                    shopLogo: '',
                    couponAmountListStr: [],
                    couponAmountList5: [
                        {
                            "cardType": "5",
                            "amount": "100",
                            "num": ""
                        },
                    ],
                    couponAmountList2: [
                        {
                            "cardType": "2",
                            "amount": "100",
                            "num": ""
                        },
                    ],
                    couponAmountList3: [
                        {
                            "cardType": "3",
                            "amount": "100",
                            "num": ""
                        },
                    ],
                    couponAmountList4: [
                        {
                            "cardType": "4",
                            "amount": "100",
                            "num": ""
                        },
                    ],
                    couponUseExplain: "<p style=\"margin-top: 10px; color: rgb(23, 43, 77); font-family: -apple-system, system-ui, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, &quot;Fira Sans&quot;, &quot;Droid Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; font-size: 14px; white-space: normal;\">1、不与该商家其他优惠同享</p><p style=\"margin-top: 10px; color: rgb(23, 43, 77); font-family: -apple-system, system-ui, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, &quot;Fira Sans&quot;, &quot;Droid Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; font-size: 14px; white-space: normal;\">2、不兑现、不找零</p><p style=\"margin-top: 10px; color: rgb(23, 43, 77); font-family: -apple-system, system-ui, &quot;Segoe UI&quot;, Roboto, Oxygen, Ubuntu, &quot;Fira Sans&quot;, &quot;Droid Sans&quot;, &quot;Helvetica Neue&quot;, sans-serif; font-size: 14px; white-space: normal;\">3、商家拥有最终解释权</p><p><br/></p>",
                    receiveExpireTime: '',
                    couponImg: '',
                    couponImgLoading: false,
                    templateType: 9,
                    relationId: '',
                    relationShopName: '',
                    circleName: '',
                    brandCardType: 0,
                }
            })
        }
        // this.getWaitForCheck();
    }

    componentWillReceiveProps() {
        // this.getWaitForCheck();
    }

    TabOnChangeCallback(key) {
        this.setState({ activeKey: key }, () => {

        })
    }

    async couponShopDetail(params) { // 获取图片信息
        let result = await API.couponShopDetail(params);
        if (!result) return;
        if (result) {
            let shopDetail = result.data;
            shopDetail.couponAmountList5 = [];
            shopDetail.couponAmountList2 = [];
            shopDetail.couponAmountList3 = [];
            shopDetail.couponAmountList4 = [];
            shopDetail.shopLogo = shopDetail.shopLogo ? JSON.parse(shopDetail.shopLogo) : ''
            shopDetail.couponImg = shopDetail.couponImg ? JSON.parse(shopDetail.couponImg) : ''
            shopDetail.couponAmountList.map((item) => {
                if (item.cardType == 1) return
                // console.log('couponAmountList', item.cardType, shopDetail[`couponAmountList${item.cardType}`])
                shopDetail[`couponAmountList${item.cardType}`].push(item)
            })
            if (shopDetail.couponAmountList5.length == 0) {
                shopDetail.couponAmountList5.push({
                    "cardType": "5",
                    "amount": "100",
                    "num": ""
                })
            }
            console.log('shopDetail', shopDetail)
            let introduceList = shopDetail.brandCardDesc ? JSON.parse(shopDetail.brandCardDesc) : ['', '']
            console.log('introduceList', introduceList)
            this.setState({
                introduceList,
                brandCardName: shopDetail.brandCardName,
                shopDetail,
            })
            return
        }
        message.error(result.msg);
    };



    // <-! 图片上传  start->
    handleChange = (type, info) => {
        console.log('info, type', info, type)
        let { shopDetail, ossData } = this.state;
        let self = this;
        if (info.file.status === 'uploading') {
            if (type == 'shopLogo') {
                shopDetail.shopLogoLoading = true
            }
            if (type == 'couponImg') {
                shopDetail.couponImgLoading = true
            }
            this.setState({ shopDetail });
            return;
        }
        if (info.file.status === 'done') {
            let imageUrl = ''
            if (type == 'shopLogo') {
                imageUrl = `${ossData.host}/${shopDetail.shopLogo_name}`
            }
            if (type == 'couponImg') {
                imageUrl = `${ossData.host}/${shopDetail.couponImg_name}`
            }
            console.log('g_object_name', imageUrl)
            this.getPictureInfo(imageUrl).then(obj => {
                if (type == 'shopLogo') {
                    shopDetail.shopLogoLoading = false
                    shopDetail.shopLogo = obj
                    self.setState({ shopDetail })
                }
                if (type == 'couponImg') {
                    shopDetail.couponImgLoading = false
                    shopDetail.couponImg = obj
                    self.setState({ shopDetail })
                }

            })
        }
    };

    beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPEG/JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    async getPictureInfo(url) { // 获取图片信息
        let result = await API.syncPic({ url });
        if (!result) return;
        if (result) {
            let picObj = {
                picture: url,
                width: result.ImageWidth.value,
                height: result.ImageHeight.value
            }
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };

    async getSignatureAndPolicy() {
        let ossData = await API.getSignatureAndPolicy();
        this.setState({ ossData })
    }

    getExtraData(type, file) {
        let { ossData, shopDetail } = this.state;
        let g_object_name = ossData.dir;

        if (file.name != '') {
            var suffix = this.get_suffix(file.name);
            g_object_name = ossData.dir + this.random_string(10) + suffix;
        }

        if ('shopLogo' == type) {
            shopDetail.shopLogo_name = g_object_name;
        }

        if ('couponImg' == type) {
            shopDetail.couponImg_name = g_object_name;
        }


        return {
            key: g_object_name,
            OSSAccessKeyId: ossData.accessid,
            policy: ossData.policy,
            signature: ossData.signature,
            success_action_status: 200
        };
    }

    get_suffix(filename) {
        var pos = filename.lastIndexOf('.');
        var suffix = '';
        if (pos != -1) {
            suffix = filename.substring(pos)
        }
        return suffix;
    }

    random_string(len) {
        len = len || 32;
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        var maxPos = chars.length;
        var pwd = '';
        for (var i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }

    // <-! 图片上传  end->

    openModel() {
        this.setState({ visible: true })
    }
    handleCancel() {
        this.setState({ visible: false })
    }
    mapChange(location) {
        let { shopDetail } = this.state;
        shopDetail.location = location
        console.log('shopDetail', shopDetail)
        this.setState({ shopDetail, visible: false })
    }


    selectHandleChange(cardType, index, value) {
        let { shopDetail } = this.state;
        shopDetail[`couponAmountList${cardType}`][index].amount = value
        this.setState({ shopDetail })
    }

    couponAmountListStrInputChange(cardType, target, index, e) {
        console.log('e', e.target.value)
        let { shopDetail } = this.state;
        let value = e.target.value;
        if ('amount' == target && value) {
            value = value * 100
        }
        shopDetail[`couponAmountList${cardType}`][index][target] = value
        this.setState({ shopDetail })
    }

    handleUEditorChange = content => { //编辑器
        let couponUseExplain = content.trim();
        let { shopDetail } = this.state;
        shopDetail.couponUseExplain = couponUseExplain;
        this.setState({ shopDetail })
    }

    inputChange(name, e) {
        console.log('e', e.target.value)
        let { shopDetail } = this.state;
        shopDetail[name] = e.target.value
        this.setState({ shopDetail })
    }

    changeRadio(name, e) {
        console.log('e', e.target.value)
        let { shopDetail } = this.state;
        shopDetail[name] = e.target.value
        this.setState({ shopDetail })
    }

    remove(cardType, index) {
        let { shopDetail } = this.state;
        shopDetail[`couponAmountList${cardType}`].splice(index, 1)
        this.setState({ shopDetail })
    }

    couponAmountList(cardType) {
        let { shopDetail } = this.state;
        shopDetail[`couponAmountList${cardType}`].push({
            "cardType": cardType,
            "amount": "100",
            "num": ""
        })
        this.setState({ shopDetail })
    }

    async edit() {
        let { templateId } = this.state;
        let shopDetail = { ...this.state.shopDetail }
        this.setState({ shopDetailloading: true })
        let { couponAmountList5, couponAmountList2, couponAmountList3, couponAmountList4 } = shopDetail;
        shopDetail.couponAmountListStr = JSON.stringify([...couponAmountList5, ...couponAmountList2, ...couponAmountList3, ...couponAmountList4])
        shopDetail.locationStr = JSON.stringify(shopDetail.location);
        delete shopDetail.location;
        delete shopDetail.couponAmountList
        console.log('shopDetail', shopDetail)
        let result;
        if (templateId) {
            result = await API.couponEditShop(shopDetail);
        } else {
            result = await API.couponAddShop(shopDetail);
        }
        if (!result) return;
        this.setState({ shopDetailloading: false })
        if (result.status == 1) {
            this.props.history.go(-1);
            message.success({
                content: '保存成功',
            });
            return
        }
        message.error(result.msg);
    }

    // < ! 会员卡号段 >

    async couponQueryCardList(type) {
        let { searchData } = this.state;
        if (type == 'home') {
            searchData.pageNo = 1;
        }
        let result = await API.couponQueryCardList(searchData)
        if (result.status == 1) {
            let data = result.data;
            let { pagination1 } = this.state;
            pagination1.total = Number(data.total);
            pagination1.current = searchData.pageNo;
            this.setState({
                queryCardList: data.cardList,
                pagination1
            })
        }
    }


    handleTableChangeCardNum = (pagination) => {
        let { searchData } = this.state;
        console.log('pagination.current', pagination.current)
        searchData.pageNo = pagination.current;
        const pager = { ...this.state.pagination1 };
        pager.current = pagination.current;
        this.setState({
            pagination1: pager,
            searchData
        }, () => {
            this.couponQueryCardList();
        });
    };
    handleTableChange = (pagination) => {
        let { consumeStatSearchData } = this.state;
        console.log('pagination.current', pagination.current)
        consumeStatSearchData.pageNo = pagination.current;
        const pager = { ...this.state.pagination2 };
        pager.current = pagination.current;
        this.setState({
            pagination2: pager,
            consumeStatSearchData
        }, () => {
            this.couponConsumeStat()
        });
    };

    InputItemChange(target, e) {
        let value = e.target.value.trim();//不能缺少的声明 eval表达式需要用到value
        const { searchData } = this.state;
        searchData[target] = value
        this.setState({ searchData })
    }

    searchForData() {//搜索
        this.couponQueryCardList('home');
    }

    reset() {
        let { searchData } = this.state;
        searchData.cardNum = '';
        this.setState({ searchData }, () => {
            this.couponQueryCardList('home');
        })
    }

    openAddModel(type) {
        const { authInfoModal } = this.state;
        if (type == 'auth') {
            authInfoModal.show = true;
        }
        this.setState({ authInfoModal })
    }

    async handleAddModalOk(type) {
        let { authInfoModal, cardListStr, templateId } = this.state;
        if (type == 'auth') {
            cardListStr = JSON.stringify(cardListStr.split(','))
            let result = await API.couponAddCard({
                templateId,
                cardListStr
            });
            if (!result) return;
            if (result.status == 1) {
                authInfoModal.show = false;
                this.setState({ authInfoModal })
                this.couponQueryCardList('home');
                message.success({
                    content: '添加成功',
                });
                return
            }
            message.error(result.msg);
        }
    }

    handleAddModalCancel(type) {//添加或编辑对话框点击取消后
        const { authInfoModal } = this.state;
        if (type == 'auth') {
            authInfoModal.show = false;
        }
        this.setState({ authInfoModal })
    }

    TextAreaOnChange(e) {
        this.setState({
            cardListStr: e.target.value
        })
    }

    async couponDeleteCard(data) {
        let result = await API.couponDeleteCard({
            id: data.id
        })
        if (result.status == 1) {
            message.success('删除成功');
            this.couponQueryCardList();
            return;
        }
        message.error(result.msg);
    }

    // < ! 核销统计 >

    async couponConsumeStat(type) {
        let { consumeStatSearchData } = this.state;
        if (type == 'home') {
            consumeStatSearchData.pageNo = 1;
        }
        let result = await API.couponConsumeStat(consumeStatSearchData)
        if (result.status == 1) {
            let data = result.data;
            let { pagination2 } = this.state;
            pagination2.total = Number(data.consumeCount);
            pagination2.current = consumeStatSearchData.pageNo;
            this.setState({
                consumeList: data.consumeList,
                consumeSumAmount: data.consumeSumAmount,
                pagination2
            })
        }
    }

    onSearchDateChange = (date) => { //筛选条件 ：时间范围
        let {
            consumeStatSearchData
        } = this.state;
        let startTime = '', endTime = '';
        if (date.length == 0) {
            startTime = '';
            endTime = '';
        } else {
            startTime = Math.floor(date[0].valueOf() / 1000);
            endTime = Math.floor(date[1].valueOf() / 1000);
        }
        consumeStatSearchData.startTime = startTime;
        consumeStatSearchData.endTime = endTime;

        this.setState({
            consumeStatSearchData
        }, () => {
            this.couponConsumeStat('home')
        });
    }

    couponConsumeStatExport() {
        let { consumeStatSearchData } = this.state;
        const { startTime, endTime, templateId } = consumeStatSearchData;
        let url = `http://console.im-dangdang.com/console/v1/themeflight/consumeStat/export?startTime=${startTime}&endTime=${endTime}&templateId=${templateId}`;
        window.open(url)
    }


    async queryShopQrCode(templateId) {
        let result = await API.couponConsumeStat({ templateId })
        if (result.status == 1) {
            let data = result.data;
            this.setState({
                ShopQrCode: data.ShopQrCode,
            })
        }
    }

    // < ! 办卡二维码 >

    // changeRadio(name, e) {
    //     console.log('e', e.target.value)
    //     let { shopDetail } = this.state;
    //     shopDetail[name] = e.target.value
    //     this.setState({ shopDetail })
    // }

    brandCardNameInput(e) {
        console.log('brandCardNameInput', e.target.value)
        let { brandCardName } = this.state;
        brandCardName = e.target.value;
        this.setState({ brandCardName })
    }

    introduceListRemove(index) {
        let { introduceList } = this.state;
        introduceList.splice(index, 1)
        this.setState({ introduceList })
    }

    introduceListAdd() {
        let { introduceList } = this.state;
        introduceList.push('');
        this.setState({ introduceList })
    }

    introduceListItemInput(index, e) {
        console.log('e', e.target.value)
        let { introduceList } = this.state;
        introduceList[index] = e.target.value;
        this.setState({ introduceList })
    }

    async couponEditBrandCard() {
        let { introduceList, brandCardName, templateId } = this.state;
        this.setState({ shopDetailloading: true })
        let params = {
            brandCardName,
            brandCardDesc: JSON.stringify(introduceList),
            templateId
        }
        console.log('params', params)
        let result = await API.couponEditBrandCard(params);
        if (!result) return;
        this.setState({ shopDetailloading: false })
        if (result.status == 1) {
            // this.props.history.go(-1);
            message.success({
                content: '保存成功',
            });
            return
        }
        message.error(result.msg);
    }


    render() {
        if (!this.state.shopDetail) return null;
        const {
            isNew,
            shopDetail,
            activeKey,
            visible,
            shopDetailloading,

            queryCardList,
            columnsQueryCardList,
            searchData,
            pagination1,
            pagination2,
            authInfoModal,
            cardListStr,

            columnsConsumeList,
            consumeList,
            consumeSumAmount,

            introduceList,
            brandCardName,
        } = this.state;


        const {
            shopName,
            shopAddress,
            location,
            adminPhones,
            shopLogo,
            shopLogoLoading,
            brandCardType,
            couponAmountList5,
            couponAmountList2,
            couponAmountList3,
            couponAmountList4,
            couponUseExplain,
            receiveExpireTime,
            couponImg,
            couponImgLoading,
            templateType,
            relationId,
            relationShopName,
            circleName,
            shopQrCode,
            brandCardQrCode,
        } = shopDetail;
        return (
            <ConfigProvider locale={zhCN}>
                <div className="ShopDetail">
                    <Tabs activeKey={activeKey} onChange={this.TabOnChangeCallback.bind(this)}>
                        <TabPane tab="商家详情" key="1">
                            <Form>
                                <Form.Item label="商家名称" hasFeedback labelAlign='left' required>
                                    <Input defaultValue={shopName} value={shopName} onChange={this.inputChange.bind(this, 'shopName')} allowClear />
                                </Form.Item>
                                <Form.Item label="商家Logo">
                                    <Upload
                                        data={this.getExtraData.bind(this, 'shopLogo')}
                                        name="file"
                                        listType="picture-card"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        action={`//dangdangshejiao.oss-cn-beijing.aliyuncs.com/`}
                                        beforeUpload={this.beforeUpload.bind(this)}
                                        onChange={this.handleChange.bind(this, 'shopLogo')}
                                    >
                                        {
                                            shopLogo ?
                                                <img src={shopLogo.picture} alt="avatar" style={{ width: '100%' }} /> :
                                                <div>
                                                    <Icon type={shopLogoLoading ? 'loading' : 'plus'} />
                                                    <div className="ant-upload-text">上传Logo</div>
                                                </div>
                                        }
                                    </Upload>
                                </Form.Item>
                                <Form.Item label="商家地址" hasFeedback required>
                                    <Input defaultValue={shopAddress} value={shopAddress} onChange={this.inputChange.bind(this, 'shopAddress')} />
                                </Form.Item>
                                <Form.Item label="商家位置" required>
                                    <Button onClick={this.openModel.bind(this)} type="link" block>{location ? location.name : '请选择位置'}</Button>
                                    <MapModel onChange={this.mapChange.bind(this)} visible={visible} handleCancel={this.handleCancel.bind(this)} location={location} />
                                </Form.Item>
                                <Form.Item label="管理员手机号" hasFeedback required>
                                    <Input placeholder='注册铛铛的手机号，多个号英文逗号隔开' defaultValue={adminPhones} value={adminPhones} onChange={this.inputChange.bind(this, 'adminPhones')} />
                                </Form.Item>
                                <Form.Item label="消费券赠送数量" hasFeedback required>
                                    <Form.Item label="会员卡" className='couponAmountList'>
                                        <Radio.Group onChange={this.changeRadio.bind(this, 'brandCardType')} defaultValue={brandCardType} value={brandCardType}>
                                            <Radio value={0}>非联名卡</Radio>
                                            <Radio value={1}>联名卡</Radio>
                                        </Radio.Group>
                                        {
                                            couponAmountList5.map((item, index) => {
                                                return (
                                                    <div className='couponAmountListItem' key={index}>
                                                        <Form.Item
                                                        // style={{ width: '180px', margin: '0 4px' }}
                                                        >
                                                            {/* <Select defaultValue={item.amount} style={{ width: 120 }} onChange={this.selectHandleChange.bind(this, '2', index)}>
                                                                <Option value="100">100</Option>
                                                                <Option value="200">200</Option>
                                                                <Option value="500">500</Option>
                                                                <Option value="1000">1000</Option>
                                                            </Select> */}
                                                            <Input maxLength={5} style={{ width: '100px', margin: '0 4px' }} defaultValue={item.amount ? item.amount / 100 : ''} value={item.amount ? item.amount / 100 : ''} onChange={this.couponAmountListStrInputChange.bind(this, '5', 'amount', index)} />
                                                            <span>元</span>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name="month"
                                                            rules={[{ required: true }]}
                                                            style={{ width: '60px', margin: '0 4px' }}
                                                        >
                                                            <Input maxLength={2} style={{ width: '50px', margin: '0 4px' }} defaultValue={item.num} value={item.num} onChange={this.couponAmountListStrInputChange.bind(this, '5', 'num', index)} />
                                                        </Form.Item>
                                                        <span style={{ margin: '0 8px 0 0' }}>张</span>
                                                        {
                                                            index != 0 ? <Icon
                                                                className="dynamic-delete-button"
                                                                type="minus-circle"
                                                                onClick={() => this.remove('5', index)}
                                                            /> : <Icon type="plus-circle" onClick={() => this.couponAmountList('5', index)} />
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </Form.Item>
                                    <Form.Item label="金卡" className='couponAmountList'>
                                        {
                                            couponAmountList2.map((item, index) => {
                                                return (
                                                    <div className='couponAmountListItem' key={index}>
                                                        <Form.Item
                                                        // style={{ width: '180px', margin: '0 4px' }}
                                                        >
                                                            {/* <Select defaultValue={item.amount} style={{ width: 120 }} onChange={this.selectHandleChange.bind(this, '2', index)}>
                                                                <Option value="100">100</Option>
                                                                <Option value="200">200</Option>
                                                                <Option value="500">500</Option>
                                                                <Option value="1000">1000</Option>
                                                            </Select> */}
                                                            <Input maxLength={5} style={{ width: '100px', margin: '0 4px' }} defaultValue={item.amount ? item.amount / 100 : ''} value={item.amount ? item.amount / 100 : ''} onChange={this.couponAmountListStrInputChange.bind(this, '2', 'amount', index)} />
                                                            <span>元</span>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name="month"
                                                            rules={[{ required: true }]}
                                                            style={{ width: '60px', margin: '0 4px' }}
                                                        >
                                                            <Input maxLength={2} style={{ width: '50px', margin: '0 4px' }} defaultValue={item.num} value={item.num} onChange={this.couponAmountListStrInputChange.bind(this, '2', 'num', index)} />
                                                        </Form.Item>
                                                        <span style={{ margin: '0 8px 0 0' }}>张</span>
                                                        {
                                                            index != 0 ? <Icon
                                                                className="dynamic-delete-button"
                                                                type="minus-circle"
                                                                onClick={() => this.remove('2', index)}
                                                            /> : <Icon type="plus-circle" onClick={() => this.couponAmountList('2', index)} />
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </Form.Item>
                                    <Form.Item label="白金卡" className='couponAmountList'>
                                        {
                                            couponAmountList3.map((item, index) => {
                                                return (
                                                    <div className='couponAmountListItem' key={index}>
                                                        <Form.Item
                                                        // style={{ width: '180px', margin: '0 4px' }}
                                                        >
                                                            {/* <Select defaultValue={item.amount} style={{ width: 120 }} onChange={this.selectHandleChange.bind(this, '3', index)}>
                                                                <Option value="100">100</Option>
                                                                <Option value="200">200</Option>
                                                                <Option value="500">500</Option>
                                                                <Option value="1000">1000</Option>
                                                            </Select> */}
                                                            <Input maxLength={5} style={{ width: '100px', margin: '0 4px' }} defaultValue={item.amount ? item.amount / 100 : ''} value={item.amount ? item.amount / 100 : ''} onChange={this.couponAmountListStrInputChange.bind(this, '3', 'amount', index)} />
                                                            <span>元</span>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name="month"
                                                            rules={[{ required: true }]}
                                                            style={{ width: '60px', margin: '0 4px' }}
                                                        >
                                                            <Input maxLength={2} style={{ width: '50px', margin: '0 4px' }} defaultValue={item.num} value={item.num} onChange={this.couponAmountListStrInputChange.bind(this, '3', 'num', index)} />
                                                        </Form.Item>
                                                        <span style={{ margin: '0 8px 0 0' }}>张</span>
                                                        {
                                                            index != 0 ? <Icon
                                                                className="dynamic-delete-button"
                                                                type="minus-circle"
                                                                onClick={() => this.remove('3', index)}
                                                            /> : <Icon type="plus-circle" onClick={() => this.couponAmountList('3', index)} />
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </Form.Item>
                                    <Form.Item label="钻石卡" className='couponAmountList'>
                                        {
                                            couponAmountList4.map((item, index) => {
                                                return (
                                                    <div className='couponAmountListItem' key={index}>
                                                        <Form.Item>
                                                            <Input maxLength={5} style={{ width: '100px', margin: '0 4px' }} defaultValue={item.amount ? item.amount / 100 : ''} value={item.amount ? item.amount / 100 : ''} onChange={this.couponAmountListStrInputChange.bind(this, '4', 'amount', index)} />
                                                            <span>元</span>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name="month"
                                                            rules={[{ required: true }]}
                                                            style={{ width: '60px', margin: '0 4px' }}
                                                        >
                                                            <Input maxLength={2} style={{ width: '50px', margin: '0 4px' }} defaultValue={item.num} value={item.num} onChange={this.couponAmountListStrInputChange.bind(this, '4', 'num', index)} />
                                                        </Form.Item>
                                                        <span style={{ margin: '0 8px 0 0' }}>张</span>
                                                        {
                                                            index != 0 ? <Icon
                                                                className="dynamic-delete-button"
                                                                type="minus-circle"
                                                                onClick={() => this.remove('4', index)}
                                                            /> : <Icon type="plus-circle" onClick={() => this.couponAmountList('4', index)} />
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </Form.Item>
                                </Form.Item>
                                <Form.Item label="消费券使用规则" className='editorModel'>
                                    {
                                        <UEditor
                                            id={'myeditor'}
                                            content={couponUseExplain}
                                            onChange={this.handleUEditorChange.bind(this)}
                                        />
                                    }

                                </Form.Item>
                                <Form.Item label="消费券有效期" hasFeedback required>
                                    <Input defaultValue={receiveExpireTime} value={receiveExpireTime} onChange={this.inputChange.bind(this, 'receiveExpireTime')} />天
                                </Form.Item>
                                <Form.Item label="消费券配图">
                                    <Upload
                                        data={this.getExtraData.bind(this, 'couponImg')}
                                        name="file"
                                        listType="picture-card"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        action={`//dangdangshejiao.oss-cn-beijing.aliyuncs.com/`}
                                        beforeUpload={this.beforeUpload.bind(this)}
                                        onChange={this.handleChange.bind(this, 'couponImg')}
                                    >
                                        {
                                            couponImg ?
                                                <img src={couponImg.picture} alt="avatar" style={{ width: '100%' }} /> :
                                                <div>
                                                    <Icon type={couponImgLoading ? 'loading' : 'plus'} />
                                                    <div className="ant-upload-text">上传配图</div>
                                                </div>
                                        }
                                    </Upload>
                                </Form.Item>
                                <Form.Item label="买单方式" hasFeedback required>
                                    <Radio.Group onChange={this.changeRadio.bind(this, 'templateType')} defaultValue={templateType} value={templateType}>
                                        <Radio value={9}>仅核销消费券</Radio>
                                        <Radio value={8}>全额买单</Radio>
                                        <Radio value={11}>全额买单+购物</Radio>
                                        <Radio value={10}>核销消费券+购物</Radio>
                                    </Radio.Group>
                                    {
                                        templateType != 9 && <Input placeholder='请输入商家ID' defaultValue={relationId} value={relationId} onChange={this.inputChange.bind(this, 'relationId')} />
                                    }
                                    {
                                        templateType != 9 && <span style={{ marginLeft: '10px' }}>{relationShopName}       {circleName}</span>
                                    }
                                </Form.Item>
                            </Form>

                            <Button
                                type="primary"
                                onClick={this.edit.bind(this)}
                                loading={shopDetailloading}
                                className='add'
                            >保存</Button>

                        </TabPane>
                        {
                            !isNew && <TabPane tab='会员卡号段' key="2">
                                <div className='search-model'>
                                    <Input className='input-userId' style={{ margin: '0 20px 0px 0' }} value={searchData.cardNum} onChange={this.InputItemChange.bind(this, 'cardNum')} placeholder="卡号"></Input>
                                    <Button type="primary" onClick={this.searchForData.bind(this)}>搜索</Button>
                                    <Button type="primary" onClick={this.reset.bind(this)} style={{ marginLeft: '20px' }}>重置</Button>
                                </div>
                                <Button type="primary" onClick={this.openAddModel.bind(this, 'auth')} style={{ marginBottom: '20px' }}>添加</Button>
                                <Table columns={columnsQueryCardList}
                                    dataSource={queryCardList}
                                    pagination={pagination1}
                                    onChange={this.handleTableChangeCardNum.bind(this)}
                                    rowKey={(row, index) => 'authList' + row.id + '-' + index}
                                />
                                <Modal
                                    destroyOnClose={true}
                                    title='添加会员卡号'
                                    onCancel={this.handleAddModalCancel.bind(this, 'auth')}
                                    visible={authInfoModal.show}
                                    width={500}
                                    onOk={this.handleAddModalOk.bind(this, 'auth')}
                                >
                                    <div className="modalPane">
                                        <TextArea rows={8} value={cardListStr} allowClear onChange={(e) => this.TextAreaOnChange(e)} />
                                        <Alert className='alertError' message="输入卡号以英文逗号隔开(eg: 1111111,222222 )" type="error" />
                                    </div>
                                </Modal>
                            </TabPane>
                        }
                        {
                            !isNew && <TabPane tab="核销数据统计" key="3">
                                <div className="searchPane">
                                    <div className="leftCondition">
                                        <RangePicker
                                            className="rangePicker"
                                            showTime={{ format: 'HH:mm:ss' }}
                                            format="YYYY-MM-DD HH:mm:ss"
                                            onChange={this.onSearchDateChange.bind(this)}
                                        ></RangePicker>
                                    </div>
                                    <div className='consumeSumAmount'>总核销金额{consumeSumAmount}元</div>
                                    <Button onClick={this.couponConsumeStatExport.bind(this)} style={{ marginLeft: '20px' }} >导出</Button>
                                </div>
                                <Table columns={columnsConsumeList}
                                    dataSource={consumeList}
                                    pagination={pagination2}
                                    onChange={this.handleTableChange.bind(this)}
                                    rowKey={(row, index) => 'awardList' + row.rewardId + '-' + index}
                                />
                            </TabPane>
                        }
                        {
                            !isNew && <TabPane tab="商家二维码" key="4">
                                <Form.Item label="消费券有效期" hasFeedback required>
                                    <Input defaultValue={receiveExpireTime} value={receiveExpireTime} onChange={this.inputChange.bind(this, 'receiveExpireTime')} />天
                                </Form.Item>
                                <div className="qrcode">
                                    <img src={shopQrCode} alt="" />
                                </div>
                                <Button onClick={() => { window.open(shopQrCode) }}>下载</Button>
                            </TabPane>
                        }
                        {
                            !isNew && brandCardType == 1 && <TabPane tab="联名卡" key="5">
                                <Form.Item label="卡片名称" hasFeedback required>
                                    <Input defaultValue={brandCardName} value={brandCardName} onChange={this.brandCardNameInput.bind(this)} />
                                </Form.Item>
                                <Form.Item label="介绍" hasFeedback required className='introduceList'>
                                    {
                                        introduceList.map((item, index) => {
                                            return (
                                                <div className='introduceListItem' key={index}>
                                                    <Form.Item className='introduceListItemInput'>
                                                        <Input defaultValue={item} value={item} onChange={this.introduceListItemInput.bind(this, index)} />
                                                    </Form.Item>
                                                    {
                                                        index != 0 ? <Icon
                                                            className="dynamic-delete-button"
                                                            type="minus-circle"
                                                            onClick={() => this.introduceListRemove(index)}
                                                        /> : <Icon type="plus-circle" onClick={() => this.introduceListAdd(index)} />
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </Form.Item>
                                <Button
                                    type="primary"
                                    onClick={this.couponEditBrandCard.bind(this)}
                                    loading={shopDetailloading}
                                    className='add'
                                >保存</Button>
                                <div className="card_code">
                                    <img src={brandCardQrCode} alt="" />
                                </div>
                                <Button onClick={() => { window.open(brandCardQrCode) }}>下载</Button>
                            </TabPane>
                        }
                    </Tabs>
                </div>
            </ConfigProvider>
        )
    }
}

export default ShopDetail;